import axios from "axios";
import {getConfig} from "./utility";

const initialState = {
    persons: [],
    person: {person: {customerSelections: []}, sites: [], educations: [], kol: [], personCustomerSelection: []},
    links: [],
    fetchingPersons: false,
    fetchingLinks: false,
    fetchingSingle: false
};

const PERSONS_FETCH = "PERSONS_FETCH";
const PERSON_FETCH = "PERSON_FETCH";
const LINKS_FETCH = "LINKS_FETCH";
const SEARCH = "SEARCH_PERSON";

export default (state = initialState, action) => {
    switch (action.type) {
        case PERSONS_FETCH:
            switch (action.status) {
                case 0:
                    return {...state, fetchingPersons: true};
                case 1:
                    return {...state, persons: action.persons, fetchingPersons: false};
                default:
                    return {...state, fetchingPersons: false}
            }
        case PERSON_FETCH:
            switch (action.status) {
                case 0:
                    return {...state, fetchingSingle: true};
                case 1:
                    return {...state, person: action.person, fetchingSingle: false};
                default:
                    return {...state, fetchingSingle: false}
            }
        case LINKS_FETCH:
            switch (action.status) {
                case 0:
                    return {...state, fetchingLinks: true};
                case 1:
                    return {...state, links: action.links, fetchingLinks: false};
                default:
                    return {...state, fetchingLinks: false}
            }
        case SEARCH:
            switch (action.status) {
                case 0:
                    return {...state, fetchingPersons: true};
                case 1:
                    return {...state, persons: action.persons, fetchingPersons: false};
                default:
                    return {...state, fetchingPersons: false}
            }
        default:
            return state
    }
}


/**
 * get persons
 */
const getPersonsReq = () => ({type: PERSONS_FETCH, status: 0});
const getPersonsRec = persons => ({type: PERSONS_FETCH, status: 1, persons});
const getPersonsErr = error => ({type: PERSONS_FETCH, status: -1, error});
export const getPersons = () => (dispatch, getState) => {
    dispatch(getPersonsReq());
    return axios.get("/person", getConfig(getState))
        .then(res => dispatch(getPersonsRec(res.data)))
        .catch(err => dispatch(getPersonsErr(err)))
};

/**
 * Get detailed person
 */
const getPersonReq = (id) => ({type: PERSON_FETCH, status: 0, id});
const getPersonRec = person => ({type: PERSON_FETCH, status: 1, person});
const getPersonErr = error => ({type: PERSON_FETCH, status: -1, error});
export const getPerson = (id, isMdm) => (dispatch, getState) => {
    dispatch(getPersonReq(id));
    const path = isMdm ? "/person/mdm/" : "/person/"
    return axios.get(path + id, getConfig(getState))
        .then(res => dispatch(getPersonRec(res.data)))
        .catch(err => dispatch(getPersonErr(err)))
};

const getLinksReq = (persId) => ({type: LINKS_FETCH, status: 0, persId});
const getLinksSuc = links => ({type: LINKS_FETCH, status: 1, links});
const getLinksErr = error => ({type: LINKS_FETCH, status: -1, error});
export const getLinks = (persId) => (dispatch, getState) => {
    dispatch(getLinksReq(persId));
    return axios.get(`/person/${persId}/links`, getConfig(getState))
        .then(res => dispatch(getLinksSuc(res.data)))
        .catch(err => dispatch(getLinksErr(err)))
};

const searchReq = request => ({type: SEARCH, status: 0, request});
const searchSuc = persons => ({type: SEARCH, status: 1, persons});
const searchErr = error => ({type: SEARCH, status: -1, error});
export const search = (request) => (dispatch, getState) => {
    dispatch(searchReq(request));
    return axios.post('/person/search', request, getConfig(getState))
        .then(res => dispatch(searchSuc(res.data)))
        .catch(err => dispatch(searchErr(err)))
};


// WEBPACK FOOTER //
// ./src/js/reducers/person.js